import type { CategoryId, IFlattenedCategory } from "app/common/services/categoryService.types";
import type { FC } from "react";
import categoryService from "app/common/services/categoryService";
import {
    BoldText,
    CHANGE_COLOR_ON_HOVER,
    Container,
    Link,
    ParentCategoryCellContainer,
} from "app/components/React/Table/cells/category-cell/styled";
import { allTrackers } from "app/services/track/track";
import { ChildCategoryCell } from "app/components/React/Table/cells/category-cell/ChildCategoryCell";

interface ICategoryCell {
    value: CategoryId;
    row: Record<string, unknown>;
    trackOnClick?: (category: IFlattenedCategory) => void;
}
const defaultTrackOnClick = (category: IFlattenedCategory) => {
    const { id } = category;
    allTrackers.trackEvent("Internal Link", "click", `Table/categoryCell/${id}`);
};

export const CategoryCell: FC<ICategoryCell> = (props) => {
    const { value: categoryID, row, trackOnClick = defaultTrackOnClick } = props;
    const href = row.categoryHref as string;
    const categories = categoryService.getFlattenedCategoriesList();
    const category = categories.find(({ id }) => id === categoryID);

    if (!category) {
        return null;
    }

    const { isChild } = category;
    return (
        <Container
            isClickable={Boolean(href)}
            onClick={() => trackOnClick(category)}
        >
            {isChild ? (
                <ChildCategoryCell
                    category={category}
                    href={href}
                />
            ) : (
                <ParentCategoryCellContainer>
                    <BoldText>
                        {href ? (
                            <Link
                                className={CHANGE_COLOR_ON_HOVER}
                                href={href}
                            >
                                {category.text}
                            </Link>
                        ) : (
                            category.text
                        )}
                    </BoldText>
                </ParentCategoryCellContainer>
            )}
        </Container>
    );
};
